import React from 'react';
import { shape, bool, func, string } from 'prop-types';
import { gql, graphql, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { operations } from 'state/ducks/map';
import LoadingIndicator from 'components/LoadingIndicator';
import List from '../List';
import ListItem from '../ListItem';
import LocationsListItem from '../LocationsListItem';

import EmptyPanelState from '../EmptyPanelState';

const LocationsQuery = gql`
  query Locations {
    locations {
      id
      name
      trackingDevice {
        id
        name
        status
        batteryVoltage
        temperature
        reportInterval
        lastUpdate
        numberOfHitsToday
        hitsToday
      }
    }
  }
`;

export function Locations({ data, selectEntity, enterEntity, leaveEntity, currentHover }) {
  if (data.loading) {
    return <LoadingIndicator />;
  }

  // We don't have any segments yet
  if (!data.locations || data.locations.length === 0) {
    return <EmptyPanelState panelType={'location'} />;
  }

  const items = data.locations.map(location => {
    const { id, trackingDevice } = location;
    const status = trackingDevice.status;
    const isActive = currentHover && currentHover.id === id;

    return (
      <ListItem
        id={id}
        key={id}
        status={status}
        isActive={isActive}
        onClick={() => selectEntity({ id, type: 'location' })}
        onMouseOver={() => enterEntity({ id, type: 'location' })}
        onMouseOut={() => leaveEntity({ id, type: 'location' })}
        contentType="location"
      >
        <LocationsListItem location={location} />
      </ListItem>
    );
  });

  return (
    <List>
      {items}
    </List>
  );
}

Locations.propTypes = {
  data: shape({
    loading: bool.isRequired,
    location: shape({}),
  }).isRequired,
  selectEntity: func.isRequired,
  enterEntity: func.isRequired,
  leaveEntity: func.isRequired,
  currentHover: shape({
    id: string.isRequired,
  }),
};

const mapStateToProps = ({ map }, ownProps) => ({
  currentHover: map.currentHover,
  ...ownProps,
});

const ConnectedLocationsWithData = compose(
  connect(mapStateToProps, operations),
  graphql(LocationsQuery, {
    options: ({ params }) => ({
      variables: {
        id: params.id,
      },
    }),
  })
)(Locations);

export default ConnectedLocationsWithData;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/Locations/index.js